const parametrizationCurveWeightHeader = [
  {
    group: 'Id',
    columns: [
      {
        name: 'Id',
        id: 'id-id',
        show: false
      }
    ]
  },
  {
    group: 'Curva',
    columns: [
      {
        name: 'Nome',
        id: 'curva-nome',
        show: true
      },
      {
        name: 'Peso Loja',
        id: 'peso-loja',
        show: true
      },
      {
        name: 'Peso Empresa',
        id: 'peso-empresa',
        show: true
      },
      {
        name: 'Peso Volume',
        id: 'peso-volume',
        show: true
      },
      {
        name: 'Peso Curva',
        id: 'peso-curva',
        show: true
      },
      {
        name: 'Corte Inicial',
        id: 'corte-inicial',
        show: true
      },
      {
        name: 'Corte Final',
        id: 'corte-final',
        show: true
      }
    ]
  }
]

export default parametrizationCurveWeightHeader
